"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTargetUrl = void 0;
var _isOriflameUrl = require("./isOriflameUrl");
/**
 * Retrieves the URL to link to based on the document referrer.
 *
 * @returns {string} The URL to link to. If the code is running on the server or during build, returns '/'.
 * If the referrer is empty (indicating the user navigated directly or from a different domain), returns '/'.
 */
const getTargetUrl = () => {
  // On server/during build, we don't know referrer
  if (typeof window === 'undefined') {
    return '/';
  }
  const {
    referrer
  } = document;
  return (0, _isOriflameUrl.isOriflameUrl)(referrer) ? referrer : '/';
};
exports.getTargetUrl = getTargetUrl;
